import React from "react";
import { BiCheckDouble } from "react-icons/bi";

const LeftMessgeSection = ({ text, time, isSeen }) => {
  return (
    <>
      <div className="flex justify-end mt-3 relative">
        <div className="p-3 bg-[#284184] text-[#fff] rounded-s-xl rounded-l-xl rounded-t-xl max-w-[300px]">
          <span className="text-base">{text}</span>
          <p className="flex items-center gap-1 justify-end text-[#fff] bottom-1 right-3">
            <span className="text-sm mt-1">{time}</span>
            {isSeen && (
              <span>
                <BiCheckDouble color="#fff" size={20} />
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default LeftMessgeSection;
